/* eslint-disable prefer-destructuring */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  MdClose,
  MdOutlineCreate,
  MdOutlineEmail,
  MdOutlineFilterAlt,
  MdOutlineWhatsapp,
} from 'react-icons/md';
import { IoMdEye, IoMdEyeOff } from 'react-icons/io';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import CountdownTimer from '../../shared/components/countdown-timer/CountdownTimer';
import {
  formatDate,
  getDateWithHypends,
  getGroupedFlightOptions,
  getNewDate,
  isEmpty,
  isMobileWidth,
} from '../../shared/helper-utils/appUtils';
import {
  API_DATE_FORMAT,
  DATE_MONTH_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  ONLY_DATE_MONTH_FORMAT,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import {
  emailFlightOptions,
  getPassThroughInfo,
  searchFlightsApi,
  validateFlightPriceApi,
} from '../../api/flightApi';
import ModifySearch from '../flights/ModifySearch';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import './FlightDomesticMultiCityPage.scss';
import AppPreviewLoader from '../../shared/components/app-preview-loader/AppPreviewLoader';
import NoSearchResults from '../one-way/NoSearchResults';
import DomMultiCityResultsCard from './DomMultiCityResultsCard';
import { debounce } from '../../api/apiUtils';
import OneWayFilters from '../one-way/OneWayFilters';
import DomMultiCityResultsFooter from './DomMultiCityResultsFooter';
import {
  getObjectFromLS,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import AppSidebar from '../../shared/components/app-sidebar/AppSidebar';
import AppModal from '../../shared/components/app-modal/AppModal';
import DomMultiCityWhatsappModel from './DomMultiCityWhatsappModel';
import DomMultiCityEmailContent from './DomMultiCityEmailContent';
import { getUserDetails } from '../../api/profileApi';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';

const DOMESTIC_SEARCH_AIRLINES = ['All', '6E'];

const DOMESTIC_CORPORATE_SEARCH_AIRLINES = ['AI', 'UK', '6E'];

function FlightDomesticMultiCityPage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const FIFTEEN_MIN_IN_MILLI_SECS = 11 * 60 * 1000;
  const NOW_IN_MILLI_SECS = getNewDate(TODAY_DATE).getTime();
  const [fifteenMinFromNowInMilli] = useState(
    NOW_IN_MILLI_SECS + FIFTEEN_MIN_IN_MILLI_SECS,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);
  const showProgressRef = useRef(true);
  const [alert, setAlert] = useState(undefined);
  const [abortController, setAbortController] = useState(new AbortController());
  const [searchRequest, setSearchRequest] = useState(undefined);
  const flightCarriesRef = useRef([]);
  const allSearchResultsRef = useRef([]);
  const flightFaresRef = useRef([]);
  const [minFlightFare, setMinFlightFare] = useState(0);
  const [maxFlightFare, setMaxFlightFare] = useState(0);
  const [hasSearchResults, setHasSearchResults] = useState(undefined);
  const [isModifySearch, setIsModifySearch] = useState(false);
  const [searchArr, setSearchArr] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const selectedSectorRef = useRef('');
  const [selectedFilters, setSelectedFilters] = useState({
    selectedMinPrice: minFlightFare,
    selectedMaxPrice: maxFlightFare,
    selectedStops: [],
    selectedDepartureTimes: [],
    selectedArraivalTimes: [],
    selectedCarriers: [],
    selectedRefundStatus: [],
    selectedFlightNumber: '',
    selectedEquipment: '',
    isSameDayArraival: false,
    selectedFareTypes: [],
  });
  const sortOrderRef = useRef({});
  const sortParamRef = useRef({});
  const [isAmPmFormatSelected, setIsAmPmFormatSelected] = useState(false);
  const [shownResults, setShownResults] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedFares, setSelectedFare] = useState({});
  const [selectedFlights, setSelectedFlights] = useState({});
  const [showFooter, setShowFooter] = useState(false);
  const [openFilters, setOpenFilters] = useState(false);
  const [selectedForEmail, setSelectedForEmail] = useState({});
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openWhatsappModal, setOpenWhatsappModal] = useState(false);
  const agentid = getUserAgentId();
  const [showInvoiceFare, setShowInvoiceFare] = useState(false);

  const appendResults = (pageNumber, results) => {
    const secResults = results.filter(
      (x) =>
        `${x.recommendedflight[0].flightlegs[0].origin} - ${
          x.recommendedflight[0].flightlegs[
            x.recommendedflight[0].flightlegs.length - 1
          ].destination
        } - ${x.recommendedflight[0].flightlegs[0].depdate}` ===
        selectedSectorRef.current,
    );
    const startindex = pageNumber * 10;
    const endIndex = startindex + 10;
    let newResults;
    if (startindex > secResults.length) {
      return;
    }
    if (endIndex > secResults.length) {
      newResults = secResults.slice(0, secResults.length);
    } else {
      newResults = secResults.slice(0, endIndex);
    }
    setShownResults(newResults);
  };

  useEffect(() => {
    appendResults(page, searchResults);
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollY } = window;
      const pageHeight =
        document.documentElement.scrollHeight - window.innerHeight - 100;
      if (scrollY >= pageHeight) {
        setPage((prev) => prev + 1);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleApplyFilter = debounce((filters) => {
    setOpenFilters(false);
    const results = allSearchResultsRef.current.filter(
      (x) =>
        `${x.recommendedflight[0].flightlegs[0].origin} - ${
          x.recommendedflight[0].flightlegs[
            x.recommendedflight[0].flightlegs.length - 1
          ].destination
        } - ${x.recommendedflight[0].flightlegs[0].depdate}` ===
        selectedSectorRef.current,
    );
    setSelectedFilters(filters);
    let filteredSearchResults =
      filters.selectedCarriers.length > 0
        ? results.filter((resultRow) => {
            let legs = resultRow.recommendedflight[0].flightlegs;
            legs = Array.isArray(legs) ? legs : [legs];
            return legs.some(
              (x) =>
                filters.selectedCarriers.indexOf(x.validatingcarriername) > -1,
            );
          })
        : results;
    filteredSearchResults =
      filters.selectedRefundStatus.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            let fares = resultRow.recommendedflight[0].flightfare;
            fares = Array.isArray(fares) ? fares : [fares];
            return fares.some(
              (x) =>
                filters.selectedRefundStatus.indexOf(x.refundableinfo) > -1,
            );
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedStops.length > 0
        ? filteredSearchResults.filter(
            (resultRow) =>
              filters.selectedStops.indexOf(
                resultRow.recommendedflight[0].numstops.toString(),
              ) > -1,
          )
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedDepartureTimes.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            const depTime = Number(
              resultRow.recommendedflight[0].flightlegs[0].deptime,
            );
            return filters.selectedDepartureTimes.some((timeRange) => {
              const timeRangeArr = timeRange.split('-');
              return (
                depTime >= Number(timeRangeArr[0]) &&
                depTime <= Number(timeRangeArr[1])
              );
            });
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedArraivalTimes.length > 0
        ? filteredSearchResults.filter((resultRow) => {
            const depTime = Number(
              resultRow.recommendedflight[0].flightlegs[
                resultRow.recommendedflight[0].flightlegs.length - 1
              ].arrtime,
            );
            return filters.selectedArraivalTimes.some((timeRange) => {
              const timeRangeArr = timeRange.split('-');
              return (
                depTime >= Number(timeRangeArr[0]) &&
                depTime <= Number(timeRangeArr[1])
              );
            });
          })
        : filteredSearchResults;
    filteredSearchResults = filters.selectedMinPrice
      ? filteredSearchResults.filter(
          (resultRow) =>
            resultRow.recommendedflight[0].flightfare[0].totalfq >=
            filters.selectedMinPrice,
        )
      : filteredSearchResults;
    filteredSearchResults = filters.selectedMaxPrice
      ? filteredSearchResults.filter(
          (resultRow) =>
            resultRow.recommendedflight[0].flightfare[0].totalfq <=
            filters.selectedMaxPrice,
        )
      : filteredSearchResults;
    filteredSearchResults =
      filters.selectedFlightNumber !== ''
        ? filteredSearchResults.filter((resultRow) => {
            const carrier = filters.selectedFlightNumber
              .toLowerCase()
              .split('-')[0]
              .substring(0, 2);
            const fltNum = filters.selectedFlightNumber.split('-')[1];
            let legs = resultRow.recommendedflight[0].flightlegs;
            legs = Array.isArray(legs) ? legs : [legs];
            if (fltNum) {
              return legs.some(
                (x) =>
                  x.carrier.toLowerCase().indexOf(carrier) > -1 &&
                  x.flightnumber.indexOf(fltNum) > -1,
              );
            }
            return legs.some(
              (x) => x.carrier.toLowerCase().indexOf(carrier) > -1,
            );
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.selectedEquipment !== ''
        ? filteredSearchResults.filter((resultRow) => {
            let legs = resultRow.recommendedflight[0].flightlegs;
            legs = Array.isArray(legs) ? legs : [legs];
            return legs.some(
              (x) =>
                x.equipment
                  .toLowerCase()
                  .indexOf(filters.selectedEquipment.toLowerCase()) > -1,
            );
          })
        : filteredSearchResults;
    filteredSearchResults =
      filters.isSameDayArraival === true
        ? filteredSearchResults.filter(
            (resultRow) =>
              resultRow.recommendedflight[0].flightlegs[0].depdate ===
              resultRow.recommendedflight[0].flightlegs[
                resultRow.recommendedflight[0].flightlegs.length - 1
              ].arrdate,
          )
        : filteredSearchResults;
    if (filters.selectedFareTypes.length > 0) {
      filteredSearchResults.forEach((resultRow) => {
        let fares = resultRow.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        const filteredFares = fares.filter(
          (x) => filters.selectedFareTypes.indexOf(x.faretype) > -1,
        );
        resultRow.recommendedflight[0].flightfare = filteredFares;
      });
      filteredSearchResults = filteredSearchResults.filter((resultRow) => {
        const fares = resultRow.recommendedflight[0].flightfare;
        return fares.length > 0;
      });
    }
    setSearchResults(filteredSearchResults);
    setPage(0);
    appendResults(0, filteredSearchResults);
  }, 300);

  useEffect(() => {
    if (hasSearchResults) {
      handleApplyFilter(selectedFilters);
    }
  }, [allSearchResultsRef.current]);

  const updateFlightsState = (response) => {
    if (
      response &&
      response.flightjourneys[0] !== '' &&
      response.flightjourneys[0] !== undefined &&
      response.flightjourneys[0].flightoptions.length !== 0
    ) {
      const flightOptions = Array.isArray(
        response.flightjourneys[0].flightoptions,
      )
        ? response.flightjourneys[0].flightoptions
        : [response.flightjourneys[0].flightoptions];
      flightOptions?.forEach((ele) => {
        let legs = ele.recommendedflight[0].flightlegs;
        legs = Array.isArray(legs) ? legs : [legs];
        const { validatingcarriername, validatingcarrier } = legs[0];
        if (!isEmpty(validatingcarriername) && !isEmpty(validatingcarrier)) {
          if (
            !flightCarriesRef.current.some(
              (x) => x.validatingcarriername === validatingcarriername,
            )
          ) {
            flightCarriesRef.current.push({
              validatingcarriername,
              validatingcarrier,
            });
          }
          flightCarriesRef.current.sort((option1, option2) =>
            option1.validatingcarriername.localeCompare(
              option2.validatingcarriername,
            ),
          );
        }
      });

      flightOptions.forEach((fo) => {
        let fares = fo.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          const carrierList = [];
          const seatsList = [];
          const bagList = [];
          const weighlist = [];
          const bookingClassList = [];
          const airFreeTextList = [];
          const handBagWeightList = [];
          const handBagWeightUnitList = [];
          fo.recommendedflight[0].flightlegs.forEach((leg) => {
            carrierList.push(leg.carrier);
            seatsList.push(leg.numseatsavailable);
            bagList.push(leg.bagweight);
            weighlist.push(leg.bagunit);
            bookingClassList.push(leg.bookingclass);
            if (leg.weather_origin !== '') {
              airFreeTextList.push(leg.weather_origin);
            }
            handBagWeightList.push(leg.cabinBagweight);
            handBagWeightUnitList.push(leg.cabinBagunit);
          });
          fare.supplierName = fo.recommendedflight[0].supplier;
          fare.nextraflightkey = fo.recommendedflight[0].nextraflightkey;
          fare.nextracustomstr = fo.recommendedflight[0].nextracustomstr;
          fare.flightCarrier = carrierList;
          fare.numseatsavailable = seatsList;
          fare.flightBagWeight = bagList;
          fare.flightBagUnit = weighlist;
          fare.bookingClass = bookingClassList;
          fare.airFreeText = airFreeTextList;
          fare.cabinBagweight = handBagWeightList;
          fare.cabinBagunit = handBagWeightUnitList;
        });
      });
      const allFlights = [...flightOptions, ...allSearchResultsRef.current];

      let groupedFlightOptions = getGroupedFlightOptions(allFlights);
      groupedFlightOptions = Object.values(groupedFlightOptions);
      const updatedGroupedOptions = [...groupedFlightOptions];
      updatedGroupedOptions.sort(
        (flightOption1, flightOption2) =>
          flightOption1.recommendedflight[0].flightfare[0].totalfq -
          flightOption2.recommendedflight[0].flightfare[0].totalfq,
      );
      let minFare = minFlightFare;
      let maxFare = maxFlightFare;

      if (updatedGroupedOptions.length > 1) {
        minFare =
          updatedGroupedOptions[0].recommendedflight[0].flightfare[0].totalfq;
        maxFare =
          updatedGroupedOptions[updatedGroupedOptions.length - 1]
            .recommendedflight[0].flightfare[0].totalfq;
      }
      allSearchResultsRef.current = updatedGroupedOptions;
      allSearchResultsRef.current.forEach((ele) => {
        let fares = ele.recommendedflight[0].flightfare;
        fares = Array.isArray(fares) ? fares : [fares];
        fares.forEach((fare) => {
          if (!flightFaresRef.current.some((x) => x === fare.faretype)) {
            flightFaresRef.current.push(fare.faretype);
          }
        });
      });
      setMinFlightFare(minFare);
      setMaxFlightFare(maxFare);
      setSearchResults(updatedGroupedOptions);
      setHasSearchResults(true);
    }
  };

  const sendParallelRequests = async (mergedSearchObj, controller) => {
    const originArr = mergedSearchObj.origin.split(':');
    const destinationArr = mergedSearchObj.destination.split(':');
    const originLocationArr = mergedSearchObj.originlocations.split(':');
    const destinationLocationArr =
      mergedSearchObj.destinationlocations.split(':');
    const newDatesArray = [];
    const datesArray = mergedSearchObj.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    const list = [];
    const fareList = {};
    const selectedMailList = {};
    selectedSectorRef.current = `${originArr[0]} - ${destinationArr[0]} - ${newDatesArray[0]}`;
    originArr.forEach((d, index) => {
      sortOrderRef.current[
        `${d} - ${destinationArr[index]} - ${newDatesArray[index]}`
      ] = 'asc';
      sortParamRef.current[
        `${d} - ${destinationArr[index]} - ${newDatesArray[index]}`
      ] = 'price';
      fareList[`${d} - ${destinationArr[index]} - ${newDatesArray[index]}`] =
        undefined;
      list.push({
        origin: d,
        destination: destinationArr[index],
        origin_name: originLocationArr[index],
        destination_name: destinationLocationArr[index],
        onwarddate: newDatesArray[index],
        sector: `${d} - ${destinationArr[index]} - ${newDatesArray[index]}`,
      });
      selectedMailList[
        `${d} - ${destinationArr[index]} - ${newDatesArray[index]}`
      ] = [];
    });
    setSelectedFare(fareList);
    setSelectedFlights(fareList);
    setSearchArr(list);
    setSelectedForEmail(selectedMailList);

    let current = 1;
    const airlinesLength =
      (DOMESTIC_SEARCH_AIRLINES.length +
        DOMESTIC_CORPORATE_SEARCH_AIRLINES.length) *
      originArr.length;
    originArr.forEach((d, index) => {
      DOMESTIC_SEARCH_AIRLINES.forEach(async (airline) => {
        mergedSearchObj.origin = d;
        mergedSearchObj.destination = destinationArr[index];
        mergedSearchObj.onwarddate = newDatesArray[index];
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'normal';
        mergedSearchObj.journeytype = 'OneWay';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
      DOMESTIC_CORPORATE_SEARCH_AIRLINES.forEach(async (airline) => {
        mergedSearchObj.origin = d;
        mergedSearchObj.destination = destinationArr[index];
        mergedSearchObj.onwarddate = newDatesArray[index];
        mergedSearchObj.prefcarrier = airline;
        mergedSearchObj.searchtype = 'corporateonly';
        mergedSearchObj.journeytype = 'OneWay';
        try {
          const response = await searchFlightsApi(mergedSearchObj, controller);
          if (current === airlinesLength) {
            showProgressRef.current = false;
          }
          setProgressWidth((current * 100) / airlinesLength);
          current += 1;
          updateFlightsState(response);
        } catch (error) {
          // console.error(error);
        }
      });
    });
  };

  const getFlightSearchResults = async (mergedSearchObj, controller) => {
    sendParallelRequests(mergedSearchObj, controller);
  };
  const resetSearchResults = () => {
    setHasSearchResults(undefined);
    setShowFooter(false);
    selectedSectorRef.current = '';
    setIsAmPmFormatSelected(false);
    setSelectedFare({});
    setSelectedFlights({});
    setSelectedFilters({
      selectedMinPrice: 0,
      selectedMaxPrice: 0,
      selectedStops: [],
      selectedDepartureTimes: [],
      selectedArraivalTimes: [],
      selectedCarriers: [],
      selectedRefundStatus: [],
      selectedFlightNumber: '',
      selectedEquipment: '',
      isSameDayArraival: false,
      selectedFareTypes: [],
    });
    setMinFlightFare(0);
    setMaxFlightFare(0);
    setSearchResults([]);
    setProgressWidth(0);
    setIsModifySearch(false);
    allSearchResultsRef.current = [];
    flightCarriesRef.current = [];
    flightFaresRef.current = [];
    showProgressRef.current = true;
    setPage(0);
    setSelectedForEmail({});
  };

  useEffect(() => {
    setAbortController(new AbortController());
    if (searchParams) {
      const currentParams = Object.fromEntries([...searchParams]);
      setSearchRequest(currentParams);
      const searchObj = {
        origin: '',
        destination: '',
        onwarddate: getNewDate(TODAY_DATE),
        returndate: '',
        numadults: '1',
        numchildren: '0',
        numinfants: '0',
        journeytype: 'OneWay',
        prefclass: 'Y',
        requestformat: 'JSON',
        resultformat: 'JSON',
        searchtype: 'normal',
        sortkey: '',
        issbt: 'false',
        profileid: '',
        numresults: 100,
        actionname: 'FLIGHTSEARCH',
        preddeptimewindow: null,
        prefarrtimewindow: null,
        prefcarrier: '',
        prefcarrierall: 'All',
        excludecarriers: '',
        refundtype: 'All',
        layovertime: '',
        promocode: '',
      };
      const mergedSearchObj = { ...searchObj, ...currentParams };
      const controller = abortController;
      const { signal } = controller;
      resetSearchResults();
      if (mergedSearchObj.nonstopsearch === 'true') {
        setSelectedFilters((prev) => ({
          ...prev,
          selectedStops: ['0'],
        }));
      }
      getFlightSearchResults(mergedSearchObj, signal);
    }
    return () => {
      if (abortController) {
        abortController.abort(); // Clean up controller on component unmount or query change
      }
    };
  }, [searchParams]);
  const handleFareSelection = (flight, fare) => {
    const tempFlights = { ...selectedFlights };
    tempFlights[selectedSectorRef.current] = flight;
    const tempFares = { ...selectedFares };
    tempFares[selectedSectorRef.current] = fare;
    setSelectedFare(tempFares);
    setSelectedFlights(tempFlights);
  };

  const getShowStatus = () => {
    let isShow = false;
    Object.keys(selectedFares).forEach((x) => {
      if (selectedFares[x] !== undefined) {
        isShow = true;
      }
    });
    setShowFooter(isShow);
  };
  useEffect(() => {
    getShowStatus();
  }, [selectedFares]);

  const handleFlightSelectionForEmail = (flight, fare) => {
    const prevSelectedItems = { ...selectedForEmail };
    const isPresent = prevSelectedItems[selectedSectorRef.current].some(
      (x) => x.fare.nextraflightkey === fare.nextraflightkey,
    );
    if (isPresent) {
      const selectedIndex = prevSelectedItems[
        selectedSectorRef.current
      ].findIndex((x) => x.fare.nextraflightkey === fare.nextraflightkey);
      prevSelectedItems[selectedSectorRef.current].splice(selectedIndex, 1);
    } else {
      prevSelectedItems[selectedSectorRef.current].push({ flight, fare });
    }
    setSelectedForEmail(prevSelectedItems);
  };
  const handleOpenEmailModal = () => {
    let hasNotSelectedAll = false;
    Object.keys(selectedForEmail).forEach((sector) => {
      if (selectedForEmail[sector].length === 0) {
        hasNotSelectedAll = true;
      }
    });
    if (!hasNotSelectedAll) {
      setOpenEmailModal(true);
    } else {
      setAlert({
        title: 'Email',
        description: 'Select atleast one fare',
        variant: 'error',
      });
    }
  };

  const handleopenWhatsappModal = () => {
    let hasNotSelectedAll = false;
    Object.keys(selectedForEmail).forEach((sector) => {
      if (selectedForEmail[sector].length === 0) {
        hasNotSelectedAll = true;
      }
    });
    if (!hasNotSelectedAll) {
      setOpenWhatsappModal(true);
    } else {
      setAlert({
        title: 'WhatsApp',
        description: 'Select All Sectors  fare',
        variant: 'error',
      });
    }
  };
  const handleSendWhatsappMessage = (whatsappNumber, msg) => {
    setIsLoading(true);
    const encodedMessage = encodeURIComponent(msg);
    const whatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    window.open(whatsAppUrl, '_blank');
    setOpenWhatsappModal(false);
    const prevSelectedItems = { ...selectedForEmail };
    Object.keys(selectedForEmail).forEach((x) => {
      prevSelectedItems[x] = [];
    });
    setSelectedForEmail(prevSelectedItems);
    setIsLoading(false);
  };

  const handleSendEmailMessage = async (senderEmail, emailContent) => {
    setIsLoading(true);
    let fromEmail = '';
    let fromName = '';
    const res = await getUserDetails(agentid);
    if (res.ApiStatus?.Status === 'OK') {
      const { User } = res.ApiStatus.Result;
      fromEmail = User.ContactEmail;
      fromName = `${User.FirstName} ${User.LastName}`;
    }
    if (fromEmail !== '') {
      let emailSubject = 'Your flight booking details for ';
      searchRequest.origin.split(':').forEach((d, index) => {
        emailSubject += `${
          searchRequest.originlocations.split(':')[index].split(',')[0]
        } - ${
          searchRequest.destinationlocations.split(':')[index].split(',')[0]
        } | ${getDateWithHypends(searchRequest.onwarddate.split(':')[index])} ${
          index !== searchRequest.origin.split(':').length - 1 ? ',' : ''
        }`;
      });
      const response = await emailFlightOptions(
        fromEmail,
        fromName,
        senderEmail,
        emailContent,
        emailSubject,
      );
      if (response && response.Root?.Status === 'OK') {
        setAlert({
          title: 'Email',
          description: 'Email Sent Successfully',
          variant: 'success',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      } else {
        setAlert({
          title: 'Email',
          description: response.Root?.Message
            ? response.Root?.Message
            : 'Failed to send email',
          variant: 'error ',
        });
        setOpenEmailModal(false);
        setIsLoading(false);
      }
    } else {
      setAlert({
        title: 'User Details',
        description: res.ApiStatus?.Message
          ? res.ApiStatus?.Message
          : 'Failed to load Agent Details',
        variant: 'error ',
      });
      setOpenEmailModal(false);
      setIsLoading(false);
    }
    const prevSelectedItems = { ...selectedForEmail };
    Object.keys(selectedForEmail).forEach((x) => {
      prevSelectedItems[x] = [];
    });
    setSelectedForEmail(prevSelectedItems);
  };
  const handleDirectNavigateToBookingPage = () => {};

  const handleTimeFormatChange = (isAmPmFormat) => {
    setIsAmPmFormatSelected(isAmPmFormat);
  };

  const handleNavigateToBookingPage = (res) => {
    const flight = {};
    const fare = {};
    const fareKeys = {};
    Object.keys(res).forEach((x) => {
      flight[x] =
        res[x].flightjourneys[0].flightoptions[0].recommendedflight[0];
      fare[x] =
        res[
          x
        ].flightjourneys[0].flightoptions[0].recommendedflight[0].flightfare;
      fareKeys[x] = selectedFares[x].nextraflightkey;
    });
    navigate(NAVIGATION_ROUTES.FLIGHT.DOM_MULTICITY_BOOKING_ROUTE, {
      state: {
        searchRequest,
        rePriceResponse: res,
        selectedFlight: flight,
        selectedFare: fare,
        selectedFareKeys: fareKeys,
        journeyType: 'oneway',
        domInt: 'domestic',
      },
    });
  };

  const handleSectorSelection = (sec) => {
    selectedSectorRef.current = sec;
    setTimeout(() => {
      handleApplyFilter(selectedFilters);
    }, 200);
  };
  const handleBook = async () => {
    const responseObj = {};
    let hasError = false;
    setIsLoading(true);
    Object.keys(selectedFares).forEach(async (x, index) => {
      try {
        const userProifle = getObjectFromLS(APP_USER_PROFILE);
        const response = await validateFlightPriceApi(
          userProifle.agentId,
          'oneway',
          selectedFares[x].nextraflightkey,
        );
        if (
          response &&
          response.NextraPricingResponseV4 &&
          response.NextraPricingResponseV4.statuscode === '200'
        ) {
          responseObj[x] = response.NextraPricingResponseV4;
        } else {
          hasError = true;
          setAlert({
            title: 'Booking Error',
            description: 'Failed to book please try again',
            variant: 'error',
          });
          setIsLoading(false);
        }
        if (
          hasError === false &&
          Object.keys(responseObj).length === Object.keys(selectedFares).length
        ) {
          handleNavigateToBookingPage(responseObj);
          setIsLoading(false);
        }
      } catch (error) {
        // setIsLoading(false);
      }
    });
  };

  const getSearchRequest = () => {
    const req = { ...searchRequest };
    const originArr = searchRequest.origin.split(':');
    const destinationArr = searchRequest.destination.split(':');
    const originLocationArr = searchRequest.originlocations.split(':');
    const destinationLocationArr =
      searchRequest.destinationlocations.split(':');
    const newDatesArray = [];
    const datesArray = searchRequest.onwarddate.split(':');
    datesArray.forEach((date) => {
      const newdate = `${date.substring(0, 4)}-${date.substring(
        4,
        6,
      )}-${date.substring(6, 8)}`;
      newDatesArray.push(newdate);
    });
    const selectedIndex = originArr.indexOf(
      selectedSectorRef.current.split(' - ')[0],
    );
    req.origin = originArr[selectedIndex];
    req.destination = destinationArr[selectedIndex];
    req.onwarddate = newDatesArray[selectedIndex];
    req.originLocation = originLocationArr[selectedIndex];
    req.destinationLocation = destinationLocationArr[selectedIndex];
    req.journeytype = 'OneWay';
    return req;
  };

  const hasResultsForSector = () => {
    const results = searchResults.filter(
      (x) =>
        `${x.recommendedflight[0].flightlegs[0].origin} - ${
          x.recommendedflight[0].flightlegs[
            x.recommendedflight[0].flightlegs.length - 1
          ].destination
        } - ${x.recommendedflight[0].flightlegs[0].depdate}` ===
        selectedSectorRef.current,
    );
    if (results.length > 0) {
      return true;
    }
    return false;
  };

  return (
    <div className="flight-domestic-multi-city-results-page">
      {showProgressRef.current && (
        <div className="flight-progress-container">
          <ProgressBar striped variant="info" now={progressWidth} />
        </div>
      )}
      <AppLoading isLoading={isLoading} />
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <div className="countdown-timer-container visually-hidden">
        <CountdownTimer
          targetDate={fifteenMinFromNowInMilli}
          continueBtnText="Continue"
          continueRoutePath="Refresh"
        />
      </div>
      {searchRequest && (
        <>
          {!isMobileWidth() ? (
            <div className="modify-search-container">
              <ModifySearch
                isModifySearch={isModifySearch}
                previousSearchRequest={searchRequest}
              />
            </div>
          ) : (
            <div className="modify-search-container">
              <div className="d-flex justify-content-between p-2 align-items-center">
                {searchArr.length > 0 && (
                  <div className="modify-search-container_multicity">
                    {searchArr.map((d) => (
                      <div
                        key={`${d.origin} - ${d.destination}`}
                        className="fs-14 white-color d-flex flex-column justify-content-center align-items-center"
                      >
                        <span>{`${d.origin} to ${d.destination}`}</span>
                        <span>
                          {formatDate(
                            getNewDate(d.onwarddate),
                            ONLY_DATE_MONTH_FORMAT,
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                )}

                <div className="d-flex  align-items-center">
                  {isModifySearch ? (
                    <AppIconButton
                      className="white-color"
                      variant="transparent"
                      onClick={() => setIsModifySearch(false)}
                    >
                      <MdClose className="fs-4" />
                    </AppIconButton>
                  ) : (
                    <AppIconButton
                      className="white-color"
                      variant="transparent"
                      onClick={() => setIsModifySearch(true)}
                    >
                      <MdOutlineCreate className="fs-4" />
                    </AppIconButton>
                  )}
                  <AppIconButton
                    className="white-color"
                    variant="transparent"
                    onClick={() => setOpenFilters(true)}
                  >
                    <MdOutlineFilterAlt className="fs-4" />
                  </AppIconButton>
                </div>
              </div>
              {isModifySearch && (
                <div className="slide-container">
                  <ModifySearch
                    isModifySearch={isModifySearch}
                    previousSearchRequest={searchRequest}
                  />
                </div>
              )}
            </div>
          )}
          {progressWidth < 100 && hasSearchResults === undefined && (
            <AppPreviewLoader />
          )}
          {hasSearchResults ? (
            <div className="flight-app-container px-sm-3 p-1 pb-3">
              <Row className="spacing-8">
                <Col lg={3} className="hide-in-mobile">
                  <OneWayFilters
                    minPrice={minFlightFare}
                    maxPrice={maxFlightFare}
                    carriers={flightCarriesRef.current}
                    fareTypes={flightFaresRef.current}
                    selectedFilters={selectedFilters}
                    onApplyFilter={handleApplyFilter}
                    onTimeFormatChange={handleTimeFormatChange}
                    conversionRate={1}
                    currencyOption={appConfig?.appCurrency}
                    isAmPmFormat={isAmPmFormatSelected}
                  />
                </Col>
                <Col lg={9} className={isMobileWidth() && 'mt-5 pt-3'}>
                  <div className="d-flex justify-content-end align-items-center gap-1">
                    <AppIconButton
                      variant="white"
                      className="fs-14 black-color"
                      onClick={handleopenWhatsappModal}
                    >
                      <MdOutlineWhatsapp title="WhatsApp" />
                    </AppIconButton>
                    <AppIconButton
                      variant="white"
                      className="fs-14 black-color"
                      onClick={handleOpenEmailModal}
                    >
                      <MdOutlineEmail title="Email" />
                    </AppIconButton>
                    <AppIconButton
                      variant="white"
                      className="fs-14 black-color"
                      onClick={() => setShowInvoiceFare((prev) => !prev)}
                    >
                      {showInvoiceFare ? (
                        <IoMdEyeOff title="Net Fare" />
                      ) : (
                        <IoMdEye title="Net Fare" />
                      )}
                    </AppIconButton>
                  </div>
                  {searchArr.length > 0 && (
                    <div className="my-2 flight-multi-city-sector-details d-flex align-items-center justify-content-between flight-sort-options">
                      {searchArr.map((d) => (
                        <div
                          key={`${d.origin} - ${d.destination}`}
                          className={`sort-btn d-flex flex-column align-items-center flex-1 ${
                            selectedSectorRef.current === d.sector
                              ? 'primary-background-color white-color'
                              : ''
                          }`}
                          onClick={() => handleSectorSelection(d.sector)}
                        >
                          <span className="fw-600 fs-14">{`${
                            d.origin_name.split(',')[0]
                          } to ${d.destination_name.split(',')[0]}`}</span>
                          <span className="fs-12">
                            {formatDate(
                              getNewDate(d.onwarddate),
                              DATE_MONTH_VIEW_FORMAT,
                            )}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                  {shownResults.length > 0 ? (
                    shownResults.map((row, index) => (
                      <DomMultiCityResultsCard
                        name="one_way_card"
                        domint="domestic"
                        key={row.recommendedflight[0].nextraflightkey}
                        flight={row.recommendedflight[0]}
                        selectedFare={selectedFares[selectedSectorRef.current]}
                        onFareSelection={handleFareSelection}
                        journeyType="OneWay"
                        searchRequest={getSearchRequest()}
                        onSelectForEmail={handleFlightSelectionForEmail}
                        flightsForEmail={
                          selectedForEmail[selectedSectorRef.current]
                        }
                        showInvoiceFare={showInvoiceFare}
                        index={index}
                        isAmPmFormat={isAmPmFormatSelected}
                        isOnward
                        onNavigateToBookingPage={
                          handleDirectNavigateToBookingPage
                        }
                      />
                    ))
                  ) : progressWidth === 100 && !hasResultsForSector() ? (
                    <NoSearchResults />
                  ) : (
                    <AppPreviewLoader />
                  )}
                </Col>
              </Row>
            </div>
          ) : (
            progressWidth === 100 && <NoSearchResults />
          )}
          {showFooter && (
            <DomMultiCityResultsFooter
              selectedFare={selectedFares}
              selectedFlight={selectedFlights}
              journeyType="oneway"
              domint="domestic"
              searchRequest={searchRequest}
              onBook={handleBook}
            />
          )}
        </>
      )}
      {openFilters && (
        <AppSidebar
          sidebarTitle="Filters"
          showActions
          onHideSidebar={() => setOpenFilters(false)}
          className="one-way-filters-modal position-relative p-0"
        >
          <OneWayFilters
            minPrice={minFlightFare}
            maxPrice={maxFlightFare}
            carriers={flightCarriesRef.current}
            fareTypes={flightFaresRef.current}
            selectedFilters={selectedFilters}
            onApplyFilter={handleApplyFilter}
            onTimeFormatChange={handleTimeFormatChange}
            conversionRate={1}
            currencyOption={appConfig?.appCurrency}
            isAmPmFormat={isAmPmFormatSelected}
          />
        </AppSidebar>
      )}
      {openWhatsappModal && (
        <AppModal
          modalTitle="Send Whatsapp"
          showCloseButton
          size="lg"
          onModalClose={() => setOpenWhatsappModal(false)}
        >
          <DomMultiCityWhatsappModel
            searchRequest={searchRequest}
            selectedForEmail={selectedForEmail}
            onSend={handleSendWhatsappMessage}
          />
        </AppModal>
      )}
      {openEmailModal && (
        <AppModal
          modalTitle="Send Email"
          showCloseButton
          size="lg"
          onModalClose={() => setOpenEmailModal(false)}
        >
          <DomMultiCityEmailContent
            selectedFlights={selectedForEmail}
            searchRequest={searchRequest}
            onSend={handleSendEmailMessage}
          />
        </AppModal>
      )}
    </div>
  );
}
export default FlightDomesticMultiCityPage;
